import QlikSaaSService from './QlikSaaSService';
import QlikWebSocketService from './QlikWebSocketService';
import QlikSingleSocketService from './QlikSingleSocketService';
import globalConfig from 'coeus.config';
import { qlikClient } from 'constants/environmental';

const SAAS = globalConfig.saas_client === qlikClient.SAAS;
const SINGLE_SOCKET = false;

const SocketServiceFactory = () => {
    if (SAAS) {
        return new QlikSaaSService();
    } else {
        if (SINGLE_SOCKET) {
            return new QlikSingleSocketService();
        } else {
            return new QlikWebSocketService();
        }
    }
};

export default SocketServiceFactory;
